export const subscriptionsRoot = "subscriptions";
export const getAll = "subscriptions/all";
export const getByBrand = "subscriptions/getByBrand";
export const getById = "subscriptions/getById";
export const getByUserId = "subscriptions/getByUserId";
export const postUpdate = "subscriptions/update";
export const postDelete = "subscriptions/delete";
export const postAdd = "subscriptions/create";
